import { Footer, NavigationHeader } from "@gonoodle/gn-universe-ui";
import PropTypes from "prop-types";
import Head from "next/head";
import { Link, ExternalLink } from "../containers";
import { URLS } from "../constants";
import { useUser } from "../contexts/user";

const Layout = ({
  children,
  pageTitle,
  pageDescription,
  bgColor,
  footer,
  header,
}) => {
  const { user } = useUser();

  return (
    <>
      <Head>
        <meta
          name="description"
          content={
            pageDescription ||
            "Get Your Kids Moving & Practicing Mindfulness with GoNoodle®. Start Watching Now & Get Access to Hundreds of Videos! Active Learning. Healthy Kids. Active Kids. Boost Learning."
          }
        />

        <title>GoNoodle{pageTitle ? ` | ${pageTitle}` : ""}</title>
      </Head>
      <div className="gn-page">
        {header ? (
          <NavigationHeader
            educatorUrl={URLS.EDUCATOR_URL}
            Link={Link}
            isUserRegistrationEnabled={user?.isUserRegistrationEnabled}
          />
        ) : null}

        <main role="main" className={`${bgColor} gn-main`}>
          <h1 className="sr-only">{pageTitle} Page</h1>
          {children}
        </main>
        {footer ? (
          <Footer role="contentinfo" Link={Link} ExternalLink={ExternalLink} />
        ) : null}
      </div>
    </>
  );
};

Layout.propTypes = {
  children: PropTypes.node.isRequired,
  pageTitle: PropTypes.string.isRequired,
  pageDescription: PropTypes.string.isRequired,
  bgColor: PropTypes.string,
  footer: PropTypes.bool,
  header: PropTypes.bool,
};

Layout.defaultProps = {
  bgColor: "bg-gray-900",
  footer: true,
  header: true,
};

export default Layout;
